import React, { useCallback, useRef, useEffect, useState } from 'react';

import { IconType } from 'react-icons/lib';
import { Link, useParams } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import api from '../../services/api';
import { date, hour, dateLanguage, simpleDate } from '../../utils/date';
import { Container } from './styles';
import { addHours } from 'date-fns';
import { useToast } from '../../hooks/Toast';
import { Form } from '@unform/web';

import { string } from 'yup';

import { useLanguage } from '../../hooks/Language';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import Favorite from '../../components/ClassRoomContainer/modules/Favorite';
import { useAuth } from '../../hooks/Auth';
import { useConfiguration } from '../../hooks/Configuration';
import { defaultProjectHash, hash } from '../../config';
import { loadFromJson } from '../../utils/loadFromJson';

interface IOption {
  value: string;
  label: string;
}

interface IProgram {
  date: Date;
  formatted_date?: string;
  start_hour: Date;
  formatted_start_hour?: string;
  end_date: Date;
  formatted_end_date?: string;
  title: string;
  category: string;
  room_reference_id_response: Record<string, any>;
  description: string;
}

interface IProgramFilter {
  date: Date;
  formatted_date: string;
  program: Array<IProgram>;
  simpleDate: string;
  day_reference?: string;
  category?: string;
  room_name?: string;
}

interface IProps {
  filterCategory?: string;
  removeCategory?: string;
}
const Program: React.FC<IProps> = () => {

  return (


    <Container id="cronograma" style={{ background: '#fff' }}>
      <h1 style={{ color: '#134842' }}>{'Cronograma'} </h1>



      <div style={{ width: '100%', marginTop: '30px' }}>
        <table className='table'>
          <tbody><tr>
            <td><strong style={{ color: '#134842' }}>Calendário do Simpósio</strong></td>
            <td><strong style={{ color: '#134842' }}>Períodos </strong></td>
          </tr>
            <tr>
              <td>Período de Submissão de trabalhos</td>
              <td>até 31 de outubro de 2025</td>

            </tr>
           


          </tbody>
        </table>
      </div>



    </Container >
  );
};
export default Program;
